<template>
  <div id="demo-basic-card">
    <div class="card-view">
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-full mt-2">
          <h3 class="ml-10 mt-2">THỐNG KÊ DỮ LIỆU</h3>
          <label class="text-font ml-10">Thống kê lại dữ liệu tương tác trên mạng</label>
        </div>
        <div class="vx-col md:w-1/6 w-full mt-2">

        </div>
        <div class="vx-col md:w-1/6 w-full mt-2">
          <label class="vs-input--label">Phạm vi</label>
          <v-select
            v-model="scopeSelect"
            :clearable="false"
            :options="scopeOptions"
            data-vv-validate-on="input"
            name="time"
          ></v-select>
        </div>
        <div class="vx-col md:w-1/6 w-full mt-2">
          <label class="vs-input--label">Chủ đề</label>
          <v-select
            v-model="topicSelect"
            :clearable="false"
            :options="topicOptions"
            data-vv-validate-on="input"
            name="time"
          ></v-select>
        </div>
        <div class="vx-col md:w-1/6 w-full mt-2">
          <label class="vs-input--label">Thời gian</label>
          <v-select
            v-model="timeSelect"
            :clearable="false"
            :options="timeOptions"
            data-vv-validate-on="input"
            name="time"
          ></v-select>
        </div>
      </div>
    </div>
    <div class="card-view-xh">
      <div class="vx-row">
        <div class="vx-col w-full mt-2">
          <h4 class="ml-10">ĐƯỢC NHẮC TỚI</h4>
          <div class="vx-row mt-5">
            <div class="vx-col w-full md:w-1/6 mt-5">
              <div class="ml-10">
                <h6>TỔNG SỐ LẦN ĐƯỢC NHẮC TỚI</h6>
                <h2>13684</h2>
              </div>
            </div>
            <div class="vx-col w-full md:w-1/6 mt-5">
              <h6>SỐ NGƯỜI ĐỀ CẬP</h6>
              <h2>26481</h2>
            </div>
          </div>
          <div class="vx-row mt-5">
            <div class="vx-col w-full md:w-5/6 mt-5">
              <vue-apex-charts
                type=line
                height=266
                :options="revenueComparisonLine.chartOptions"
                :series="revenueComparisonLine.series"/>
              <p class="ml-10">Biểu đồ nhắc tới <b>Tất cả chủ đề</b> ngày hôm nay</p>
            </div>
            <div class="vx-col w-full md:w-1/6" v-if="revenueComparisonLine.analyticsData">
              <div class="ml-10">
                <p>Lượt nhắc tới</p>
                <p class="text-3xl">{{this.totalAnalytics.toLocaleString() }}</p>
              </div>
              <div class="ml-10 mt-1">
                <p>Mạng xã hội</p>
                <p class="text-2xl" style="color: #5c6bbf">{{
                  revenueComparisonLine.analyticsData.socialNetwork.toLocaleString() }}</p>
              </div>
              <div class="ml-10 mt-1">
                <p>Báo online</p>
                <p class="text-2xl" style="color: #db4437">{{
                  revenueComparisonLine.analyticsData.newspaper.toLocaleString() }}</p>
              </div>
              <div class="ml-10 mt-1">
                <p>Nguồn tin khác</p>
                <p class="text-2xl" style="color: #f4b401">{{
                  revenueComparisonLine.analyticsData.otherSources.toLocaleString() }}</p>
              </div>
              <div class="ml-10">
                <p>Lượt đề cập</p>
                <p class="text-3xl">1</p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="card-view-xh">
      <div class="vx-row">
        <div class="vx-col w-full mt-2">
          <h4 class="ml-10">SẮC THÁI</h4>
          <div class="vx-row mt-5">
            <div class="vx-col w-full md:w-1/6 mt-5">
              <div class="ml-10">
                <h6>TÍCH CỰC
                  <feather-icon icon="MehIcon"
                                style="width: 20px;vertical-align:middle; margin-left: 2px; color: green"></feather-icon>
                </h6>
                <h2>2843</h2>
                <p>50% Tổng số tin</p>
              </div>
            </div>
            <div class="vx-col w-full md:w-1/6 mt-5">
              <h6>TIÊU CỰC
                <feather-icon icon="MehIcon"
                              style="width: 20px;vertical-align:middle; margin-left: 2px; color: red"></feather-icon>
              </h6>
              <h2>81</h2>
              <p>10% Tổng số tin</p>
            </div>

            <div class="vx-col w-full md:w-1/6 mt-5">
              <h6>TRUNG LẬP
                <feather-icon icon="MehIcon"
                              style="width: 20px;vertical-align:middle; margin-left: 2px; color: #f4b401"></feather-icon>
              </h6>
              <h2>2000</h2>
              <p>40% Tổng số tin</p>
            </div>

          </div>
          <div class="vx-row mt-5">
            <div class="vx-col w-full md:w-2/3 mt-5">
              <vue-apex-charts
                type=line
                height=266
                :options="revenueComparisonLineShade.chartOptions"
                :series="revenueComparisonLineShade.series"/>
              <p class="ml-10">Biểu đồ sắc thái <b>Tất cả chủ đề</b> ngày hôm nay</p>
            </div>

            <div class="vx-col w-full md:w-1/3">
              <p class="ml-24">Ngày 13/12/2020 - 09:00</p>
              <vue-apex-charts type="donut" height="250" :options="sessionsByDeviceDonut.chartOptions"
                               :series="sessionsByDeviceDonut.series"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-view-xh">
      <div class="vx-row">
        <div class="vx-col w-full mt-2">
          <h4 class="ml-10">NGUỒN TIN</h4>
          <div class="vx-row mt-5 mb-4">
            <div class="vx-col w-full md:w-1/3">
              <p class="ml-10">TỈ LỆ NGUỒN TIN</p>
              <vue-apex-charts type="pie" height="350" :options="sessionsInformationResource.chartOptions"
                               :series="sessionsInformationResource.series"/>
              <!--<p class="ml-32 mr-auto mt-12">Biểu đồ nguồn tin <b>Tất cả chủ đề</b> ngày hôm nay</p>-->
            </div>
            <div class="vx-col w-full md:w-2/3">
              <!-- Bar CHART -->
                <p class="ml-10">NGUỒN TIN TỪ BÁO CHÍ</p>
                <vue-apex-charts type="bar" height="350" :options="barChart.chartOptions" :series="barChart.series"></vue-apex-charts>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import vSelect from 'vue-select'
  import VueApexCharts from 'vue-apexcharts'

  export default {
    name: 'app',
    data() {
      return {
        barChart: {
          series: [{
            name: "Số bài đăng",
            data: [1380, 1200, 1100, 690, 580, 540, 470, 448, 430, 400]
          }],
          chartOptions: {
            colors: ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E'],
            plotOptions: {
              bar: {
                horizontal: true,
              }
            },
            dataLabels: {
              enabled: true
            },
            xaxis: {
              categories: ['dothi.net', 'tinmoi247.net', 'msn.com', 'vnanet.vn', 'baohomnay.net', 'thoibaotaichinhvietnam.vn', 'haiquanonline.com.vn',
                'dantri.com', 'hayviet.net', 'baomoi.com'
              ].reverse(),
            }
          }
        },
        revenueComparisonLineShade: {
          series: [{
            name: "Tích cực",
            data: [45000, 47000, 44800, 47500, 45500, 48000, 46500]
          },
            {
              name: "Tiêu cực",
              data: [46000, 48000, 45500, 46600, 44500, 46500, 45000]
            },
            {
              name: "Bình thường",
              data: [20000, 10000, 22500, 42600, 34500, 26500, 45000]
            }
          ],
          chartOptions: {
            chart: {
              toolbar: {show: false},
              dropShadow: {
                enabled: true,
                top: 5,
                left: 0,
                blur: 4,
                opacity: 0.10,
              },
            },
            stroke: {
              //curve: 'smooth',
              //dashArray: [0, 8],
              width: [2, 2, 2],
            },
            grid: {
              borderColor: '#e7e7e7',
            },
            legend: {
              show: false,
            },
            colors: ['#008000', '#ff0000', '#f4b401'],
            fill: {
              //type: 'gradient',
              gradient: {
                shade: 'dark',
                inverseColors: false,
                gradientToColors: ['#008000', '#ff0000', '#f4b401'],
                shadeIntensity: 1,
                type: 'horizontal',
                opacityFrom: 1,
                opacityTo: 1,
                stops: [0, 100, 100, 100]
              },
            },
            markers: {
              size: 0,
              hover: {
                size: 5
              }
            },
            xaxis: {
              labels: {
                style: {
                  cssClass: 'text-grey fill-current',
                }
              },
              axisTicks: {
                show: false,
              },
              categories: ['T2', 'T3', 'T4', 'T5', 'T6', 'T7', 'CN'],
              axisBorder: {
                show: false,
              },
            },
            yaxis: {
              tickAmount: 5,
              labels: {
                style: {
                  cssClass: 'text-grey fill-current',
                },
                formatter: function (val) {
                  return val > 999 ? (val / 1000).toFixed(1) + 'k' : val;
                }
              }
            },
            tooltip: {
              x: {show: false}
            }
          }
        },
        sessionsByDeviceDonut: {
          analyticsData: [
            {
              device: 'Tích cực',
              icon: 'MonitorIcon',
              color: 'primary',
              sessionsPercentgae: 58.6,
              comparedResultPercentage: 2
            },
            {
              device: 'Tiêu cực',
              icon: 'SmartphoneIcon',
              color: 'warning',
              sessionsPercentgae: 34.9,
              comparedResultPercentage: 8
            },
            {
              device: 'Trung lập',
              icon: 'TabletIcon',
              color: 'danger',
              sessionsPercentgae: 6.5,
              comparedResultPercentage: -5
            },
          ],
          comparedResult: [2, -3, 8],
          series: [58.6, 34.9, 6.5],
          chartOptions: {
            labels: ['Tích cực', 'Tiêu cực', 'Trung lập'],
            dataLabels: {
              enabled: true
            },
            legend: {position: 'right'},
            chart: {
              offsetY: 30,
              type: 'donut',
              toolbar: {
                show: false
              }
            },
            stroke: {width: 0},
            colors: ['#008000', '#ff0000', '#f4b401'],
            fill: {
              type: 'gradient',
              gradient: {
                gradientToColors: ['#008000', '#ff0000', '#f4b401'],
              }
            }
          }
        },
        sessionsInformationResource: {
          analyticsData: [
            {
              device: 'Mạng xã hội',
              icon: 'MonitorIcon',
              color: 'primary',
              sessionsPercentgae: 30,
              comparedResultPercentage: 2
            },
            {
              device: 'Báo và trang điện tử',
              icon: 'SmartphoneIcon',
              color: 'warning',
              sessionsPercentgae: 10,
              comparedResultPercentage: 8
            },
            {
              device: 'Diễn đàn và các nguồn khác',
              icon: 'TabletIcon',
              color: 'danger',
              sessionsPercentgae: 60,
              comparedResultPercentage: -5
            },
          ],
          comparedResult: [2, -3, 8],
          series: [30, 10, 60],
          chartOptions: {
            labels: ['Mạng xã hội', 'Báo và trang điện tử', 'Diễn đàn và các nguồn khác'],
            dataLabels: {
              enabled: true
            },
            legend: {
              position: 'bottom'
            },
            chart: {
              offsetY: 30,
              type: 'donut',
              toolbar: {
                show: false
              }
            },
            stroke: {width: 0},
            colors: ['#2d88ff', 'rgba(236,87,7,0.51)', '#f4b401'],
            fill: {
              type: 'gradient',
              gradient: {
                gradientToColors: ['#2d88ff', 'rgba(236,87,7,0.51)', '#f4b401'],
              }
            }
          }
        },
        totalAnalytics: 0,
        revenueComparisonLine: {
          analyticsData: {
            socialNetwork: 73683,
            newspaper: 86589,
            otherSources: 8652
          },
          series: [{
            name: "Mạng xã hội",
            data: [45000, 47000, 44800, 47500, 45500, 48000, 46500]
          },
            {
              name: "Báo online",
              data: [46000, 48000, 45500, 46600, 44500, 46500, 45000]
            },
            {
              name: "Forum & Nguồn tin khác",
              data: [33000, 14000, 55500, 22600, 41400, 21500, 15000]
            }
          ],
          chartOptions: {
            chart: {
              toolbar: {show: false},
              dropShadow: {
                enabled: true,
                top: 5,
                left: 0,
                blur: 4,
                opacity: 0.10,
              },
            },
            stroke: {
              curve: 'smooth',
              //dashArray: [0, 8],
              //width: [4, 2],
            },
            grid: {
              borderColor: '#e7e7e7',
            },
            legend: {
              show: false,
            },
            colors: ['#5c6bbf', '#db4437', '#f4b401'],
            fill: {
              type: 'gradient',
              gradient: {
                shade: 'dark',
                inverseColors: false,
                gradientToColors: ['#5c6bbf', '#db4437', '#f4b401'],
                shadeIntensity: 1,
                type: 'horizontal',
                opacityFrom: 1,
                opacityTo: 1,
                stops: [0, 100, 100, 100]
              },
            },
            markers: {
              size: 0,
              hover: {
                size: 5
              }
            },
            xaxis: {
              labels: {
                style: {
                  cssClass: 'text-grey fill-current',
                }
              },
              axisTicks: {
                show: false,
              },
              categories: ['T2', 'T3', 'T4', 'T5', 'T6', 'T7', 'CN'],
              axisBorder: {
                show: false,
              },
            },
            yaxis: {
              tickAmount: 5,
              labels: {
                style: {
                  cssClass: 'text-grey fill-current',
                },
                formatter: function (val) {
                  return val > 999 ? (val / 1000).toFixed(1) + 'k' : val;
                }
              }
            },
            tooltip: {
              x: {show: false}
            }
          }
        },
        scopeSelected: null,
        scopeOptions: [
          {label: 'Tổng quan', value: null},
          {label: 'Mạng xã hội', value: 0},
          {label: 'Báo chí', value: 1},
        ],

        topicSelected: null,
        topicOptions: [
          {label: 'Tất cả chủ đề', value: null},
          {label: 'InfoCare', value: 0},
          {label: 'Viettel', value: 1},
          {label: 'Smcc', value: 2},
        ],
        valueSelect: null,
        timeOptions: [
          {label: '1 ngày gần đây', value: 1},
          {label: '3 ngày gần đây', value: 3},
          {label: '7 ngày gần đây', value: 7},
          {label: '1 tháng gần đây', value: 30}
        ],
      }
    },
    components: {
      VuePerfectScrollbar,
      vSelect,
      VueApexCharts
    },
    computed: {
      validateForm: function () {
        return !this.errors.any();
      },
      timeSelect: {
        get() {
          let object = this.timeOptions.find(el => el.value === this.valueSelect);
          if (!object) {
            return {
              label: this.timeOptions[0].label,
              value: this.timeOptions[0].value
            }
          }
          return {
            label: object.label,
            value: this.valueSelect
          }
        },
        set(val) {
          this.valueSelect = val.value;
        }
      },
      topicSelect: {
        get() {
          let object = this.topicOptions.find(el => el.value === this.topicSelected);
          if (!object) {
            return null;
          }
          return {
            label: object.label,
            value: this.topicSelected
          }
        },
        set(val) {
          this.topicSelected = val.value;
        }
      },
      scopeSelect: {
        get() {
          let object = this.scopeOptions.find(el => el.value === this.scopeSelected);
          if (!object) {
            return null;
          }
          return {
            label: object.label,
            value: this.scopeSelected
          }
        },
        set(val) {
          this.scopeSelected = val.value;
        }
      }
    },
    mounted() {
    },
    created() {
      this.totalAnalytics = this.revenueComparisonLine.analyticsData.socialNetwork + this.revenueComparisonLine.analyticsData.newspaper + this.revenueComparisonLine.analyticsData.otherSources;
    },
    methods: {}
  }
</script>

<style lang="scss">
  @import "@/assets/scss/vuexy/components/vxCard.scss";

  #demo-basic-card {
    .card-view {
      border-radius: 10px;
      padding: 5px 10px 10px 10px;
      box-shadow: 0px 4px 25px 0px rgba(95, 94, 94, 0.1);
      -webkit-transition: all 0.3s ease-in-out;
      margin-top: -20px;
      margin-bottom: 30px;
    }

    .card-view-xh {
      border-radius: 10px;
      border: 1px solid #ccc;
      padding: 20px;
      box-shadow: 0px 4px 25px 0px rgba(95, 94, 94, 0.1);
      margin-bottom: 10px;
    }

    .xh {
      border-bottom: 1px solid #cccccc;
    }

    .wordCloud {
      .text {
        cursor: pointer;
      }
    }
  }
</style>
